// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import _router from "@/router";
import { Router } from "vue-router";
export const router: Router = _router;
